import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';
import { ReactComponent as Play } from '../../res/play.svg';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupTFPB from '../../popups/PopupTFPB';
import PopupSafety from '../../popups/PopupSafety';
import PopupSecularism from '../../popups/PopupSecularism';
import PopupMarieLaureVuittenez from '../../popups/PopupMarieLaureVuittenez';

import styles from './styles';

class B14lifequality extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}></div>
        <div className={classes.blur}></div>
        <div className={classes.greyCurveRight}></div>
        <div className={classes.greyCurveLeft}></div>
        <div className={classes.blueRectangle}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data, onPopup } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.main}>
          <div className={classes.main1}>
            <Typography variant="body1" className={classes.desc}>
              {parse(data.blocks.b14lifequality.desc)}
            </Typography>
            <div className={classes.quote}>
              <Typography variant="h5">{parse(data.blocks.b14lifequality.quote)}</Typography>
              <TypoFramed variant="body1">{parse(data.blocks.b14lifequality.autor)}</TypoFramed>
              <Typography variant="body1">{parse(data.blocks.b14lifequality.role)}</Typography>
              <ButtonWithIcon color="white" icon={<Add />} onClick={() => onPopup('popupMarieLaureVuittenez', true)}>
                {parse(data.blocks.b14lifequality.quoteBtn)}
              </ButtonWithIcon>
            </div>
          </div>
          <div className={classes.main2}>
            <div>
              <div className={classes.article}>
                <Typography variant="h6">{parse(data.blocks.b14lifequality.articleTitle1)}</Typography>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupTPFB', true)}>
                  {parse(data.blocks.b14lifequality.articleBtn1)}
                </ButtonWithIcon>
                <ButtonWithIcon
                  color="black"
                  icon={<Play />}
                  component="a"
                  href={parse(data.blocks.b14lifequality.articleVideo1Url)}
                  target="_blank"
                >
                  {parse(data.blocks.b14lifequality.articleVideo1)}
                </ButtonWithIcon>
              </div>
              <div className={classes.article}>
                <Typography variant="h6">{parse(data.blocks.b14lifequality.articleTitle2)}</Typography>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupSafety', true)}>
                  {parse(data.blocks.b14lifequality.articleBtn2)}
                </ButtonWithIcon>
              </div>
              <div className={classes.article}>
                <Typography variant="h6">{parse(data.blocks.b14lifequality.articleTitle3)}</Typography>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupSecularism', true)}>
                  {parse(data.blocks.b14lifequality.articleBtn3)}
                </ButtonWithIcon>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data, baseUrl, popupsState, onPopup } = this.props;
    const mainTitle = parse(data.blocks.b14lifequality.mainTitle);
    return (
      <div className={classes.blockContainer}>
        <Typography variant="h1" color="secondary" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        {this.renderBackground()}
        {this.renderContent()}
        <PopupMarieLaureVuittenez
          data={data}
          open={!!popupsState.popupMarieLaureVuittenez}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupMarieLaureVuittenez', false)}
        ></PopupMarieLaureVuittenez>
        <PopupTFPB
          data={data}
          open={!!popupsState.popupTPFB}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupTPFB', false)}
        ></PopupTFPB>
        <PopupSafety
          data={data}
          open={!!popupsState.popupSafety}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupSafety', false)}
        ></PopupSafety>
        <PopupSecularism
          data={data}
          open={!!popupsState.popupSecularism}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupSecularism', false)}
        ></PopupSecularism>
      </div>
    );
  }
}

B14lifequality.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  baseUrl: PropTypes.string,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(B14lifequality);
